import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Switch, Route } from 'react-router-dom';

import DeviceManager from '../modules/DeviceManager';

import Preloader from './Preloader';
import Footer from './Footer';
import ResponsiveScreen from './ResponsiveScreen';
import Header from './Header';
import Homepage from './Homepage';
import NotFound from './NotFound';
import About from './About';
import AllWorks from './AllWorks';

class PreloadScreen extends React.Component {
	constructor(props) {
		super(props);

        this.root = document.querySelector('html');

        if(!DeviceManager.isHandheld()) {
            this.root.classList.add('no-touch');
        }

        if(DeviceManager.isEdge()) {
            this.root.classList.add('edge');
        }
        else if(DeviceManager.isSafari()) {
            this.root.classList.add('safari');
        }
        else if(DeviceManager.isChrome()) {
            this.root.classList.add('chrome');
        }

        let orientation = window.screen.msOrientation || (window.screen.orientation || window.screen.mozOrientation || {}).type;
        let deviceWidth = (window.screen.width) ? window.screen.width : window.innerWidth;
        let deviceHeight = (window.screen.height) ? window.screen.height : window.innerHeight;

        if(((orientation === 'landscape-primary' || orientation === 'landscape-secondary') && deviceWidth >= 1024) || ((orientation === 'portrait-primary' || orientation === 'portrait-secondary') && deviceHeight >= 1024)) {
            this.root.classList.add('can-display-tablet-design');
        }
	}

	componentDidMount() {
        
	}
	
    componentWillMount() {

    }
    
    componentWillUnmount() {
        this.root = null;
    }

	render() {
		if(!this.props.preloadingDone) {
			return (
				<Preloader/>
			);
		}

		return (
			<div>
				<Header />
                <main>
    				<Switch>
                        <Route path="/about" exact component={About} />
                        <Route path="/all-works" exact component={AllWorks} />
    					<Route path="/" component={Homepage} />
    					<Route component={NotFound} />
    				</Switch>
                </main>
                <Footer />
                <ResponsiveScreen />
			</div>
		);
	};
};

const mapStateToProps = (state) => {
    return {
        assetsIsLoaded: state.assetsIsLoaded,
        preloadingDone: state.preloadingDone
    };
};

export default withRouter(connect(mapStateToProps, null)(PreloadScreen));


// WEBPACK FOOTER //
// ./src/components/PreloadScreen.js